/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Files_Details_Zerobytes1Inputs */

const en_us2_builds_files_details_zerobytes1 = /** @type {(inputs: Builds_Files_Details_Zerobytes1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0 Bytes`)
};

const es_es2_builds_files_details_zerobytes1 = /** @type {(inputs: Builds_Files_Details_Zerobytes1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0 bytes`)
};

const ru_builds_files_details_zerobytes1 = /** @type {(inputs: Builds_Files_Details_Zerobytes1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0 байт`)
};

/** @type {(inputs: Builds_Files_Details_Zerobytes1Inputs) => LocalizedString} */
const id_builds_files_details_zerobytes1 = en_us2_builds_files_details_zerobytes1;

/** @type {(inputs: Builds_Files_Details_Zerobytes1Inputs) => LocalizedString} */
const ms_builds_files_details_zerobytes1 = en_us2_builds_files_details_zerobytes1;

/** @type {(inputs: Builds_Files_Details_Zerobytes1Inputs) => LocalizedString} */
const da_builds_files_details_zerobytes1 = en_us2_builds_files_details_zerobytes1;

/** @type {(inputs: Builds_Files_Details_Zerobytes1Inputs) => LocalizedString} */
const de_builds_files_details_zerobytes1 = en_us2_builds_files_details_zerobytes1;

/** @type {(inputs: Builds_Files_Details_Zerobytes1Inputs) => LocalizedString} */
const es_mx2_builds_files_details_zerobytes1 = en_us2_builds_files_details_zerobytes1;

/** @type {(inputs: Builds_Files_Details_Zerobytes1Inputs) => LocalizedString} */
const fil_builds_files_details_zerobytes1 = en_us2_builds_files_details_zerobytes1;

/** @type {(inputs: Builds_Files_Details_Zerobytes1Inputs) => LocalizedString} */
const fr_builds_files_details_zerobytes1 = en_us2_builds_files_details_zerobytes1;

/** @type {(inputs: Builds_Files_Details_Zerobytes1Inputs) => LocalizedString} */
const it_builds_files_details_zerobytes1 = en_us2_builds_files_details_zerobytes1;

/** @type {(inputs: Builds_Files_Details_Zerobytes1Inputs) => LocalizedString} */
const hu_builds_files_details_zerobytes1 = en_us2_builds_files_details_zerobytes1;

/** @type {(inputs: Builds_Files_Details_Zerobytes1Inputs) => LocalizedString} */
const nl_builds_files_details_zerobytes1 = en_us2_builds_files_details_zerobytes1;

/** @type {(inputs: Builds_Files_Details_Zerobytes1Inputs) => LocalizedString} */
const no_builds_files_details_zerobytes1 = en_us2_builds_files_details_zerobytes1;

/** @type {(inputs: Builds_Files_Details_Zerobytes1Inputs) => LocalizedString} */
const pl_builds_files_details_zerobytes1 = en_us2_builds_files_details_zerobytes1;

/** @type {(inputs: Builds_Files_Details_Zerobytes1Inputs) => LocalizedString} */
const pt_builds_files_details_zerobytes1 = en_us2_builds_files_details_zerobytes1;

/** @type {(inputs: Builds_Files_Details_Zerobytes1Inputs) => LocalizedString} */
const pt_br2_builds_files_details_zerobytes1 = pt_builds_files_details_zerobytes1;

/** @type {(inputs: Builds_Files_Details_Zerobytes1Inputs) => LocalizedString} */
const ro_builds_files_details_zerobytes1 = en_us2_builds_files_details_zerobytes1;

/** @type {(inputs: Builds_Files_Details_Zerobytes1Inputs) => LocalizedString} */
const fi_builds_files_details_zerobytes1 = en_us2_builds_files_details_zerobytes1;

/** @type {(inputs: Builds_Files_Details_Zerobytes1Inputs) => LocalizedString} */
const sv_builds_files_details_zerobytes1 = en_us2_builds_files_details_zerobytes1;

/** @type {(inputs: Builds_Files_Details_Zerobytes1Inputs) => LocalizedString} */
const vi_builds_files_details_zerobytes1 = en_us2_builds_files_details_zerobytes1;

/** @type {(inputs: Builds_Files_Details_Zerobytes1Inputs) => LocalizedString} */
const tr_builds_files_details_zerobytes1 = en_us2_builds_files_details_zerobytes1;

/** @type {(inputs: Builds_Files_Details_Zerobytes1Inputs) => LocalizedString} */
const cs_builds_files_details_zerobytes1 = en_us2_builds_files_details_zerobytes1;

/** @type {(inputs: Builds_Files_Details_Zerobytes1Inputs) => LocalizedString} */
const bg_builds_files_details_zerobytes1 = en_us2_builds_files_details_zerobytes1;

/** @type {(inputs: Builds_Files_Details_Zerobytes1Inputs) => LocalizedString} */
const uk_builds_files_details_zerobytes1 = en_us2_builds_files_details_zerobytes1;

/** @type {(inputs: Builds_Files_Details_Zerobytes1Inputs) => LocalizedString} */
const ar_builds_files_details_zerobytes1 = en_us2_builds_files_details_zerobytes1;

/** @type {(inputs: Builds_Files_Details_Zerobytes1Inputs) => LocalizedString} */
const hi_builds_files_details_zerobytes1 = en_us2_builds_files_details_zerobytes1;

/** @type {(inputs: Builds_Files_Details_Zerobytes1Inputs) => LocalizedString} */
const th_builds_files_details_zerobytes1 = en_us2_builds_files_details_zerobytes1;

/** @type {(inputs: Builds_Files_Details_Zerobytes1Inputs) => LocalizedString} */
const ja_builds_files_details_zerobytes1 = en_us2_builds_files_details_zerobytes1;

/** @type {(inputs: Builds_Files_Details_Zerobytes1Inputs) => LocalizedString} */
const zh_cn2_builds_files_details_zerobytes1 = en_us2_builds_files_details_zerobytes1;

/** @type {(inputs: Builds_Files_Details_Zerobytes1Inputs) => LocalizedString} */
const zh_hant1_builds_files_details_zerobytes1 = en_us2_builds_files_details_zerobytes1;

/** @type {(inputs: Builds_Files_Details_Zerobytes1Inputs) => LocalizedString} */
const ko_builds_files_details_zerobytes1 = en_us2_builds_files_details_zerobytes1;

/**
* | output |
* | --- |
* | "0 Bytes" |
*
* @param {Builds_Files_Details_Zerobytes1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_files_details_zerobytes1 = /** @type {((inputs?: Builds_Files_Details_Zerobytes1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Files_Details_Zerobytes1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_files_details_zerobytes1(inputs)
	if (locale === "ms") return ms_builds_files_details_zerobytes1(inputs)
	if (locale === "da") return da_builds_files_details_zerobytes1(inputs)
	if (locale === "de") return de_builds_files_details_zerobytes1(inputs)
	if (locale === "en-US") return en_us2_builds_files_details_zerobytes1(inputs)
	if (locale === "es-ES") return es_es2_builds_files_details_zerobytes1(inputs)
	if (locale === "es-MX") return es_mx2_builds_files_details_zerobytes1(inputs)
	if (locale === "fil") return fil_builds_files_details_zerobytes1(inputs)
	if (locale === "fr") return fr_builds_files_details_zerobytes1(inputs)
	if (locale === "it") return it_builds_files_details_zerobytes1(inputs)
	if (locale === "hu") return hu_builds_files_details_zerobytes1(inputs)
	if (locale === "nl") return nl_builds_files_details_zerobytes1(inputs)
	if (locale === "no") return no_builds_files_details_zerobytes1(inputs)
	if (locale === "pl") return pl_builds_files_details_zerobytes1(inputs)
	if (locale === "pt-BR") return pt_br2_builds_files_details_zerobytes1(inputs)
	if (locale === "pt") return pt_builds_files_details_zerobytes1(inputs)
	if (locale === "ro") return ro_builds_files_details_zerobytes1(inputs)
	if (locale === "fi") return fi_builds_files_details_zerobytes1(inputs)
	if (locale === "sv") return sv_builds_files_details_zerobytes1(inputs)
	if (locale === "vi") return vi_builds_files_details_zerobytes1(inputs)
	if (locale === "tr") return tr_builds_files_details_zerobytes1(inputs)
	if (locale === "cs") return cs_builds_files_details_zerobytes1(inputs)
	if (locale === "bg") return bg_builds_files_details_zerobytes1(inputs)
	if (locale === "ru") return ru_builds_files_details_zerobytes1(inputs)
	if (locale === "uk") return uk_builds_files_details_zerobytes1(inputs)
	if (locale === "ar") return ar_builds_files_details_zerobytes1(inputs)
	if (locale === "hi") return hi_builds_files_details_zerobytes1(inputs)
	if (locale === "th") return th_builds_files_details_zerobytes1(inputs)
	if (locale === "ja") return ja_builds_files_details_zerobytes1(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_files_details_zerobytes1(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_files_details_zerobytes1(inputs)
	return ko_builds_files_details_zerobytes1(inputs)
});
export { builds_files_details_zerobytes1 as "builds.files.details.zeroBytes" }